import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Filters from "../../common/reports/Filters";
import {
  BETWEEN,
  DATE,
  GTE,
  LIKE,
  LTE,
  STRING,
} from "../../common/reports/reportConstants";
import { createFilterParam } from "../../common/reports/reportUtils";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import TextInput from "../../framework/TextInput";
import SelectInput from "../../framework/SelectInput";
import { executeScroll, isEmpty } from "../../utils/utils";
import Shortcut from "../../framework/Shortcut";
import NumberInput from "../../framework/NumberInput";
import {
  fullfillmentStatusOptions,
  statusOptions,
  transferReasons,
} from "../../utils/constant";
import { fetchBranches } from "../../services/branch-service";
import dayjs from "dayjs";
import DatePicker from "../../framework/date/DatePicker";
const MedicineWiseStockTransferReportFilter = ({
  onFilterShow,
  applyFilterOnMount = true,
  refreshData = false,
  reportRef,
}) => {
  const [transferStartDate, setTransferStartDate] = useState(
    dayjs().subtract(7, "day")
  );
  const [transferEndDate, setTransferEndDate] = useState(dayjs());
  const [product, setProduct] = useState("");
  const [batch, setBatch] = useState("");
  const [branchSuggestions, setBranchSuggestions] = useState([]);
  const [selectedFromBranch, setSelectedFromBranch] = useState([]);
  const [selectedToBranch, setSelectedToBranch] = useState([]);
  const [limit, setLimit] = useState(100);
  const [status, setStatus] = useState("");
  const [fullfillmentStatus, setFullfillmentStatus] = useState("");
  const [reason, setReason] = useState("");
  const filterStatusRef = useRef();
  const filterFullFillmentStatusRef = useRef();
  const filterReasonRef = useRef();
  const filterProductNameRef = useRef();
  const filterBatchRef = useRef();
  const filterTransferStartDateRef = useRef();
  const filterTransferEndDateRef = useRef();
  const filterFromBranchIdRef = useRef();
  const filterToBranchIdRef = useRef();
  const filterLimitRef = useRef();
  const applyFilterRef = useRef();
  const [orderBy] = useState([
    { fieldName: "stockTransferDateTime", orderType: "desc" },
  ]);
  const { setCurrentComponent } = useContext(GlobalContext);
  const handleFetchBranches = useCallback((event) => {
    setBranchSuggestions([]);
    fetchBranches(`deleted=false`).then((resp) => {
      let updatedResp = resp.result.rows.map((branch) => ({
        id: branch._id,
        label: branch.code,
      }));
      setBranchSuggestions(updatedResp);
    });
  }, []);
  const applyFilterHandler = useCallback(
    (isFilterChanged = false) => {
      let filters = [];
      let result = {};
      const _transferStartDate = transferStartDate?.format("DD/MM/YYYY");
      const _transferEndDate = transferEndDate?.format("DD/MM/YYYY");
      if (_transferStartDate && !_transferEndDate) {
        filters.push(
          createFilterParam("createdTime", _transferStartDate, DATE, GTE)
        );
      }
      if (!_transferStartDate && _transferEndDate) {
        filters.push(
          createFilterParam("createdTime", _transferEndDate, DATE, LTE)
        );
      }
      if (_transferStartDate && _transferEndDate) {
        filters.push(
          createFilterParam(
            "createdTime",
            { start: _transferStartDate, end: _transferEndDate },
            DATE,
            BETWEEN
          )
        );
      }
      if (!isEmpty(product)) {
        filters.push(createFilterParam("productName", product, "string", LIKE));
      }
      if (!isEmpty(batch)) {
        filters.push(createFilterParam("batch", batch, "string", LIKE));
      }
      if (!isEmpty(selectedFromBranch)) {
        filters.push(
          createFilterParam(
            "fromBranchId",
            selectedFromBranch?.label,
            STRING,
            LIKE
          )
        );
      }
      if (!isEmpty(selectedToBranch)) {
        filters.push(
          createFilterParam("branchId", selectedToBranch?.label, STRING, LIKE)
        );
      }
      if (!isEmpty(status)) {
        filters.push(createFilterParam("status", status, "string", LIKE));
      }
      if (!isEmpty(fullfillmentStatus)) {
        filters.push(
          createFilterParam(
            "fullfillmentStatus",
            fullfillmentStatus,
            "string",
            LIKE
          )
        );
      }
      if (!isEmpty(reason)) {
        filters.push(createFilterParam("reason", reason, "string", LIKE));
      }
      result.filters = filters;
      result.isFilterChanged = isFilterChanged;
      if (orderBy?.length) {
        result.orderBy = orderBy;
      }
      if (!isEmpty(limit)) {
        result.limit = limit;
      }

      reportRef.current?.applyFilters(result);
    },
    [
      transferStartDate,
      transferEndDate,
      product,
      batch,
      selectedFromBranch,
      selectedToBranch,
      status,
      fullfillmentStatus,
      reason,
      orderBy,
      limit,
      reportRef,
    ]
  );
  const filterListener = useCallback((event) => {
    const key = event.key.toLowerCase();
    const ctrl = event.ctrlKey;
    if (ctrl && key === "enter") {
      event.preventDefault();
      return applyFilterRef.current.click();
    }
  }, []);
  const filterContent = (
    <>
      <FilterGroup>
        <FilterItem>
          <DatePicker
            id="mwst_filter_transfer_start_date"
            label="Stock Transfer Start Date"
            inputRef={filterTransferStartDateRef}
            onChange={(value) => setTransferStartDate(value)}
            onFocus={() =>
              setCurrentComponent("mwst_filter_transfer_start_date")
            }
            value={transferStartDate}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "mwst_filter_transfer_end_date",
                down: "mwst_filter_transfer_end_date",
                left: "mwst_filter_transfer_end_date",
                right: "mwst_filter_transfer_end_date",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <DatePicker
            id="mwst_filter_transfer_end_date"
            label="Stock Transfer End Date"
            inputRef={filterTransferEndDateRef}
            onChange={(value) => setTransferEndDate(value)}
            onFocus={() => {
              executeScroll(filterTransferEndDateRef);
              setCurrentComponent("mwst_filter_transfer_end_date");
            }}
            value={transferEndDate}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "mwst_filter_transfer_start_date",
                down: "mwst_filter_product_name",
                left: "mwst_filter_transfer_start_date",
                right: "mwst_filter_product_name",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <TextInput
            id="mwst_filter_product_name"
            label="Product Name"
            ref={filterProductNameRef}
            value={product}
            onChange={(e) => setProduct(e.target.value)}
            onFocus={() => {
              setCurrentComponent("mwst_filter_product_name");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "mwst_filter_transfer_end_date",
                down: "mwst_filter_batch_no",
                left: "mwst_filter_transfer_end_date",
                right: "mwst_filter_batch_no",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <TextInput
            id="mwst_filter_batch_no"
            label="Batch Number"
            ref={filterBatchRef}
            value={batch}
            onChange={(e) => setBatch(e.target.value)}
            onFocus={() => {
              executeScroll(filterBatchRef);
              setCurrentComponent("mwst_filter_batch_no");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "mwst_filter_product_name",
                down: "mwst_filter_from_branch",
                left: "mwst_filter_product_name",
                right: "mwst_filter_from_branch",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <SelectInput
            id="mwst_filter_from_branch"
            label="From Branch"
            value={selectedFromBranch}
            ref={filterFromBranchIdRef}
            options={branchSuggestions}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => {
              return option.label === value.label;
            }}
            onChange={(e, value) => {
              setSelectedFromBranch(value);
            }}
            onFocus={() => {
              executeScroll(filterFromBranchIdRef);
              setCurrentComponent("mwst_filter_from_branch");
            }}
            disableClearable={false}
            markers={JSON.stringify({
              up: "mwst_filter_batch_no",
              down: "mwst_filter_to_branch",
              left: "mwst_filter_batch_no",
              right: "mwst_filter_to_branch",
            })}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <SelectInput
            id="mwst_filter_to_branch"
            label="To Branch"
            value={selectedToBranch}
            ref={filterToBranchIdRef}
            options={branchSuggestions}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => {
              return option.label === value.label;
            }}
            onChange={(e, value) => {
              setSelectedToBranch(value);
            }}
            onFocus={() => {
              executeScroll(filterToBranchIdRef);
              setCurrentComponent("mwst_filter_to_branch");
            }}
            disableClearable={false}
            markers={JSON.stringify({
              up: "mwst_filter_from_branch",
              down: "mwst_filter_status",
              left: "mwst_filter_from_branch",
              right: "mwst_filter_status",
            })}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <SelectInput
            id="mwst_filter_status"
            label="Status"
            ref={filterStatusRef}
            options={statusOptions.map((status) => ({
              value: status,
              label: status,
            }))}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.label
            }
            value={status}
            onChange={(e, option) => setStatus(option?.value || "")}
            onFocus={() => {
              executeScroll(filterStatusRef);
              setCurrentComponent("mwst_filter_status");
            }}
            disableClearable={false}
            markers={JSON.stringify({
              up: "mwst_filter_to_branch",
              down: "mwst_filter_fullfillment_status",
              left: "mwst_filter_to_branch",
              right: "mwst_filter_fullfillment_status",
            })}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <SelectInput
            id="mwst_filter_fullfillment_status"
            label="Fullfillment Status"
            ref={filterFullFillmentStatusRef}
            options={fullfillmentStatusOptions.map((fullfillmentStatus) => ({
              value: fullfillmentStatus,
              label: fullfillmentStatus,
            }))}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.label
            }
            value={fullfillmentStatus}
            onChange={(e, option) => setFullfillmentStatus(option?.value || "")}
            onFocus={() => {
              executeScroll(filterFullFillmentStatusRef);
              setCurrentComponent("mwst_filter_fullfillment_status");
            }}
            disableClearable={false}
            markers={JSON.stringify({
              up: "mwst_filter_status",
              down: "mwst_filter_reason",
              left: "mwst_filter_status",
              right: "mwst_filter_reason",
            })}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <SelectInput
            id="mwst_filter_reason"
            label="Transfer Reason"
            ref={filterReasonRef}
            options={transferReasons.map((reason) => ({
              value: reason,
              label: reason,
            }))}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.label
            }
            value={reason}
            onChange={(e, option) => setReason(option?.value || "")}
            onFocus={() => {
              executeScroll(filterReasonRef);
              setCurrentComponent("mwst_filter_reason");
            }}
            disableClearable={false}
            markers={JSON.stringify({
              up: "mwst_filter_fullfillment_status",
              down: "mwst_filter_limit",
              left: "mwst_filter_fullfillment_status",
              right: "mwst_filter_limit",
            })}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <NumberInput
            id="mwst_filter_limit"
            label="Limit"
            ref={filterLimitRef}
            onValueChange={(values) => setLimit(values.floatValue)}
            isAllowed={(values) => values?.formattedValue <= 999999}
            onFocus={() => {
              executeScroll(filterLimitRef);
              setCurrentComponent("mwst_filter_limit");
            }}
            value={limit}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "mwst_filter_reason",
                down: "mwst_apply_filter_button",
                left: "mwst_filter_reason",
                right: "mwst_apply_filter_button",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
    </>
  );

  const filterFooter = (
    <>
      <FilterGroup>
        <FilterItem>
          <Button
            id="mwst_apply_filter_button"
            label="Apply"
            endIcon={<Shortcut keys={["Ctrl", "Enter"]} />}
            ref={applyFilterRef}
            onClick={() => applyFilterHandler(true)}
            markers={JSON.stringify({
              up: "mwst_filter_limit",
              left: "mwst_filter_limit",
              down: "mwst_apply_filter_button",
              right: "mwst_apply_filter_button",
            })}
          />
        </FilterItem>
      </FilterGroup>
    </>
  );
  useEffect(() => {
    handleFetchBranches();
  }, [handleFetchBranches]);
  useEffect(() => {
    if (refreshData) {
      applyFilterHandler(true);
    }
  }, [refreshData, applyFilterHandler]);
  useEffect(() => {
    if (onFilterShow) {
      filterProductNameRef?.current.focus({ preventScroll: true });
    }
  }, [onFilterShow]);

  useEffect(() => {
    if (onFilterShow) document.addEventListener("keyup", filterListener, false);
    return () => {
      document.removeEventListener("keyup", filterListener, false);
    };
  }, [filterListener, onFilterShow]);

  useEffect(() => {
    if (applyFilterOnMount) applyFilterHandler();
    // eslint-disable-next-line
  }, [applyFilterOnMount]);

  return <Filters filterContent={filterContent} filterFooter={filterFooter} />;
};

export default MedicineWiseStockTransferReportFilter;
